import { UnitModel } from '../../types';
import api from '../../utils/api';

export const createUnitModel = (variables: UnitModel) =>
  api.post({
    url: `/unit-model`,
    variables,
  });
